import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { first, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Currencies } from '../../models';
import { MoneyStreamData } from '../components/money-stream/money-stream.component';

@Injectable({
  providedIn: 'root',
})
export class DashboardDataService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  getTicketsStatsByEvent(eventId: number) {
    const route = `${this.configUrl}s/e/${eventId}/tickets`;
    return this.http.get<{resold: number, sale: number, friendSale: number, sold: number}>(route).pipe(
      first(),
    );
  }

  getTicketsPerCategoryStatsByEvent(eventId: number) {
    const route = `${this.configUrl}s/e/${eventId}/tickets/categories`;
    return this.http.get<any>(route).pipe(
      first(),
    );
  }

  getAlertsStatsByEvent(eventId: number) {
    const route = `${this.configUrl}s/e/${eventId}/alerts`;
    return this.http.get<{isSubscribed: number, total: number}>(route).pipe(
      first(),
    );
  }

  getCommercialCommunicationListByEvent(eventId: number) {
    const route = `${this.configUrl}s/e/${eventId}/commercialcommunication`;
    return this.http.get<{count: number}>(route).pipe(
      first(),
    );
  }

  getSalesAmountByEvent(eventId: number) {
    const route = `${this.configUrl}s/e/${eventId}/salesAmount`;
    return this.http.get<MoneyStreamData[]>(route).pipe(
      map( (salesPerCurrency) => (salesPerCurrency.map( (sales) => ({
        ...sales,
        organizerFeesAmount:+sales.organizerFeesFlatAmount + (+sales.organizerFeesShareAmount / 10000),
      }))
      )),
      first(),
    );
  }

  getWaitListStatsByEvent(eventId: number) {
    const route = `${this.configUrl}s/e/${eventId}/waitList`;
    return this.http.get<{
      quantityActiveTotal: number,
      quantityTotal: number,
      userActiveTotal: number,
      userTotal: number,
    }>(route).pipe(
      first(),
    );
  }

}
